/*
 * @Author: wangyan1 wangyan1
 * @Date: 2023-10-24 19:21:59
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2023-11-03 10:56:37
 * @FilePath: /teacher-xkh-web/src/utils/Postmate.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { postmate } from '@aixuexi/web-sdk'
const { Parent, PLATFORM } = postmate
export const CONFIG = {
  platform: PLATFORM.XKH_TEACHER
}
export const EVENT = postmate.EVENT
export default Parent
